import { render, staticRenderFns } from "./financeiro-especialidade-procedimento.vue?vue&type=template&id=4547b32c&scoped=true"
import script from "./financeiro-especialidade-procedimento.vue?vue&type=script&lang=ts"
export * from "./financeiro-especialidade-procedimento.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-especialidade-procedimento.vue?vue&type=style&index=0&id=4547b32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4547b32c",
  null
  
)

export default component.exports